import { Injectable } from '@angular/core';
import { assign, cloneDeep } from 'lodash-es';
import { PcMockApiService, PcMockApiUtils } from 'app/shared/lib/mock-api';
import { works as worksData } from 'app/mock-api/apps/works/data';

@Injectable({
  providedIn: 'root',
})
export class WorksMockApi {
  private _works: any[] = worksData;

  /**
   * Constructor
   */
  constructor(private _pcMockApiService: PcMockApiService) {
    // Register Mock API handlers
    this.registerHandlers();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Register Mock API handlers
   */
  registerHandlers(): void {
    // -----------------------------------------------------------------------------------------------------
    // @ Works - GET
    // -----------------------------------------------------------------------------------------------------
    this._pcMockApiService.onGet('api/apps/works', 300).reply(({ request }) => {
      // Get available queries
      // const search = request.params.get('search');
      // const sort = request.params.get('sort') || 'name';
      // const order = request.params.get('order') || 'asc';
      const page = parseInt(request.params.get('page') ?? '1', 10);
      const size = parseInt(request.params.get('size') ?? '10', 10);

      // Clone the works
      let works: any[] | null = cloneDeep(this._works);

      // Sort the works
      // if ( sort === 'sku' || sort === 'name' || sort === 'active' )
      // {
      //     works.sort((a, b) => {
      //         const fieldA = a[sort].toString().toUpperCase();
      //         const fieldB = b[sort].toString().toUpperCase();
      //         return order === 'asc' ? fieldA.localeCompare(fieldB) : fieldB.localeCompare(fieldA);
      //     });
      // }
      // else
      // {
      //     works.sort((a, b) => order === 'asc' ? a[sort] - b[sort] : b[sort] - a[sort]);
      // }

      // If search exists...
      // if ( search )
      // {
      //     // Filter the works
      //     works = works.filter(works => works.name && works.name.toLowerCase().includes(search.toLowerCase()));
      // }

      // Paginate - Start
      const worksLength = works.length;

      // Calculate pagination details
      const begin = page * size;
      const end = Math.min(size * (page + 1), worksLength);
      const lastPage = Math.max(Math.ceil(worksLength / size), 1);

      // Prepare the pagination object
      let pagination = {};

      // If the requested page number is bigger than
      // the last possible page number, return null for
      // works but also send the last possible page so
      // the app can navigate to there
      if (page > lastPage) {
        works = null;
        pagination = {
          lastPage,
        };
      } else {
        // Paginate the results by size
        works = works.slice(begin, end);

        // Prepare the pagination mock-api
        pagination = {
          length: worksLength,
          size: size,
          page: page,
          lastPage: lastPage,
          startIndex: begin,
          endIndex: end - 1,
        };
      }

      // Return the response
      return [
        200,
        {
          works,
          pagination,
        },
      ];
    });

    // -----------------------------------------------------------------------------------------------------
    // @ Works - GET
    // -----------------------------------------------------------------------------------------------------
    this._pcMockApiService.onGet('api/apps/work').reply(({ request }) => {
      // Get the id from the params
      const id = request.params.get('id');

      // Clone the works
      const works = cloneDeep(this._works);

      // Find the works
      const work = works.find((item) => item.id === id);

      // Return the response
      return [200, work];
    });

    // -----------------------------------------------------------------------------------------------------
    // @ Works - POST
    // -----------------------------------------------------------------------------------------------------
    this._pcMockApiService.onPost('api/apps/works').reply(() => {
      // Generate a new works
      const newClient = {
        id: PcMockApiUtils.guid(),
        category: '',
        name: 'A New Works',
        description: '',
        tags: [],
        sku: '',
        barcode: '',
        brand: '',
        vendor: '',
        stock: '',
        reserved: '',
        cost: '',
        basePrice: '',
        taxPercent: '',
        price: '',
        weight: '',
        thumbnail: '',
        images: [],
        active: false,
      };

      // Unshift the new works
      this._works.unshift(newClient);

      // Return the response
      return [200, newClient];
    });

    // -----------------------------------------------------------------------------------------------------
    // @ Works - PATCH
    // -----------------------------------------------------------------------------------------------------
    this._pcMockApiService.onPatch('api/apps/works').reply(({ request }) => {
      // Get the id and works
      const id = request.body.id;
      const works = cloneDeep(request.body.works);

      // Prepare the updated works
      let updatedClient = null;

      // Find the works and update it
      this._works.forEach((item, index, works) => {
        if (item.id === id) {
          // Update the works
          works[index] = assign({}, works[index], works);

          // Store the updated works
          updatedClient = works[index];
        }
      });

      // Return the response
      return [200, updatedClient];
    });

    // -----------------------------------------------------------------------------------------------------
    // @ Works - DELETE
    // -----------------------------------------------------------------------------------------------------
    this._pcMockApiService.onDelete('api/apps/works').reply(({ request }) => {
      // Get the id
      const id = request.params.get('id');

      // Find the works and delete it
      this._works.forEach((item, index) => {
        if (item.id === id) {
          this._works.splice(index, 1);
        }
      });

      // Return the response
      return [200, true];
    });
  }
}
